import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

/**
 * SearchInput - Componente global de pesquisa reutilizável
 * 
 * Props:
 *   - value: string (valor atual)
 *   - onChange: (value: string) => void (callback)
 *   - placeholder?: string (default: "Pesquisar...")
 *   - searchFields?: string[] (campos para exibir no tooltip)
 *   - className?: string (classes adicionais)
 */
export default function SearchInput({
  value,
  onChange,
  placeholder = 'Pesquisar...',
  searchFields = [],
  className = '',
}) {
  const handleClear = () => {
    onChange('');
  };

  return (
    <div className={`relative w-full ${className}`}>
      <div className="relative">
        {/* Ícone de busca à esquerda */}
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
        
        {/* Input */}
        <Input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="pl-10 pr-10"
        />
        
        {/* Botão de limpar (X) quando há texto */}
        {value && (
          <button
            onClick={handleClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Limpar pesquisa"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      
      {/* Tooltip com campos de busca (opcional) */}
      {searchFields.length > 0 && (
        <div className="text-xs text-gray-500 mt-1">
          Buscando em: {searchFields.join(', ')}
        </div>
      )}
    </div>
  );
}
